<template>
  <b-container class="text-left">
    <span v-html="$t('legal-intro')"></span>
    <span v-html="$t('legal-1')"></span>
    <span v-html="$t('legal-1txt')"></span>
    <span v-html="$t('legal-2')"></span>
    <span v-html="$t('legal-2txt')"></span>
    <span v-html="$t('legal-3')"></span>
    <span v-html="$t('legal-3txt')"></span>
    <span v-html="$t('legal-4')"></span>
    <span v-html="$t('legal-4txt')"></span>
    <span v-html="$t('legal-5')"></span>
    <span v-html="$t('legal-5txt')"></span>
    <span v-html="$t('legal-6')"></span>
    <span v-html="$t('legal-6txt')"></span>
    <span v-html="$t('legal-7')"></span>
    <span v-html="$t('legal-7txt')"></span>
  </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/LegalWarning.vue